import {Line, mixins} from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'header-chart',
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    chartData () {
      this.$data._chart.update()
    }
  },
  mounted () {
    //     let chartColor = '#fff';

    // const ctx = document.getElementById(this.chartId).getContext('2d');
    // const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    // gradientStroke.addColorStop(0, '#fff');
    // gradientStroke.addColorStop(1, chartColor);
    this.renderChart(this.chartData, this.options)
  }
}
